import { CSSProperties } from 'react';
import { COLORS } from '../../globalStyles';

export const styles: Record<string, CSSProperties> = {
  grid: {
    display: 'grid',
    // Columns are set via the `.services-grid` class so a media query can
    // collapse the 2×2 grid to a single column on mobile.
    border: `1px solid ${COLORS.border}`,
    borderRadius: 0,
    overflow: 'hidden',
    marginTop: '3.5rem',
  },
};
